import { render, staticRenderFns } from "./TheNavDrawer.vue?vue&type=template&id=5412d231&"
import script from "./TheNavDrawer.vue?vue&type=script&lang=ts&"
export * from "./TheNavDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./TheNavDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VIcon,VNavigationDrawer})
